import type { VirtualizerOptions } from '@tanstack/virtual-core';
import { defaultRangeExtractor } from '@tanstack/virtual-core';

const alwaysRangeExtractor = () => {
	// Add row 0 to always include the header row. This is important because, at the time of writing,
	// adding and removing it from the DOM results in the unstable keys for the tables rows.
	// Technically, it may not be a header row. However, it is just 1 row and it is simpler to just always include it.
	return [0];
};

const combineRanges = (rangeA: number[], rangeB: number[]): number[] => {
	const combinedRange: number[] = [];
	let rangeAIndex = 0;
	let rangeBIndex = 0;
	while (rangeAIndex < rangeA.length || rangeBIndex < rangeB.length) {
		const rangeAValue = rangeA[rangeAIndex];
		const rangeBValue = rangeB[rangeBIndex];

		if (!Number.isInteger(rangeBValue) || rangeBValue > rangeAValue) {
			// Add element because it's in range A.
			combinedRange.push(rangeAValue);
			rangeAIndex++;
		} else if (!Number.isInteger(rangeAValue) || rangeAValue > rangeBValue) {
			// Add element because it's in range B.
			combinedRange.push(rangeBValue);
			rangeBIndex++;
		} else {
			// Add element because it's in both ranges.
			combinedRange.push(rangeAValue);
			rangeAIndex++;
			rangeBIndex++;
		}
	}

	return combinedRange;
};

export const customRangeExtractor: NonNullable<
	VirtualizerOptions<Element, Element>['rangeExtractor']
> = (range) => {
	const defaultRange = defaultRangeExtractor(range);
	const alwaysRange = alwaysRangeExtractor();
	const combinedRange = combineRanges(defaultRange, alwaysRange);
	return combinedRange;
};
